import {ensureString, formatDateBr, toISODate} from "../../../utils/convert-fields"

const RATING_LONG_TEXT_MAX_LENGTH = 300

const dateMask = "99/99/9999"

const ratingLongTextConfig = {
    type: "dynamicTextarea",
    longText: true,
    maxLength: RATING_LONG_TEXT_MAX_LENGTH,
    minRows: 2,
    maxRows: 5,
    md: 12,
    spacing: {pl: 0, ml: 0, mr: 0},
}

export const mapDadosGarantias = (caracteristicasState, garantiasState) => ({
    Caracteristica: {
        GarantiasReais: caracteristicasState?.garantiasReais ?? null,
        GarantiasFidejussorias: caracteristicasState?.garantiasFidejussorias ?? null,
        MitigadorRiscoCredito: caracteristicasState?.mitigadorRisco ?? null,
        CotaSubordinacao: caracteristicasState?.cotaSubordinacao ?? null,
        Coobrigacao: caracteristicasState?.cobrigacao ?? null,
    },
    Garantias: garantiasState
        ? [{
            TipoLastro: garantiasState.tipoLastro ?? null,
            AlienacaoFiduciaria: garantiasState.alienacao ?? null,
            CessaoFiduciaria: garantiasState.cessao ?? null,
            Fianca: garantiasState.fianca ?? null,
            Avalista: garantiasState.avalista ?? null,
            FiancaBancaria: garantiasState.fiancaBancaria ?? null,
            Hipoteca: garantiasState.hipoteca ?? null,
            Penhor: garantiasState.penhor ?? null,
            FundoObra: garantiasState.fundoObra ?? null,
            FundoLiquidez: garantiasState.fundoLiquidez ?? null,
            FundoReserva: garantiasState.fundoReserva ?? null,
        }]
        : [],
})

export const ratingFields = [
    {
        key: "DataReferencia",
        label: "Data Referência",
        md: 3,
        defaultValue: null,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
    },
    {
        key: "DataValidade",
        label: "Data Validade",
        md: 3,
        defaultValue: null,
        mask: dateMask,
        maskType: "date",
        minDate: "01/01/1900",
    },
    {key: "Fonte", label: "Fonte", md: 3, defaultValue: null},
    {key: "ScoreRating", label: "Score Rating", md: 3, defaultValue: null},
    {key: "Rating", label: "Rating", md: 3, defaultValue: null},
    {key: "Sinal", label: "Sinal", md: 3, defaultValue: null},
    {key: "Perspectiva", label: "Perspectiva", md: 3, defaultValue: null},
    {
        ...ratingLongTextConfig,
        key: "Observacao", 
        label: "Observação", 
        defaultValue: null
    },
    {
        ...ratingLongTextConfig,
        key: "AnaliseCreditoEmissao",
        label: "Análise Resumo Crédito",
        defaultValue: "Emissão clean com risco remetendo à qualidade creditícia do devedor."
    },
]

export const mapRatingEmissao = (ratingEmissao) => {
    return {
        "ID": ratingEmissao.ID,
        "DataReferencia": formatDateBr(ratingEmissao.DataReferencia),
        "DataValidade": formatDateBr(ratingEmissao.DataValidade),
        "Fonte": ensureString(ratingEmissao.Fonte),
        "ScoreRating": ensureString(ratingEmissao.ScoreRating),
        "Rating": ensureString(ratingEmissao.Rating),
        "Sinal": ensureString(ratingEmissao.Sinal),
        "Perspectiva": ensureString(ratingEmissao.Perspectiva),
        "Observacao": ensureString(ratingEmissao.Observacao),
        "AnaliseCreditoEmissao": ensureString(ratingEmissao.AnaliseCreditoEmissao)
    }
}

export const mapPayloadRatingEmissao = (cetip, ratingEmissao) => ({    
    CETIP: cetip.toUpperCase(),
    DataReferencia: toISODate(ratingEmissao.DataReferencia),
    DataValidade: toISODate(ratingEmissao.DataValidade),
    Fonte: ensureString(ratingEmissao.Fonte),
    ScoreRating: ensureString(ratingEmissao.ScoreRating),
    Rating: ensureString(ratingEmissao.Rating),
    Sinal: ensureString(ratingEmissao.Sinal) || null,
    Perspectiva: ensureString(ratingEmissao.Perspectiva),
    Observacao: ensureString(ratingEmissao.Observacao) || null,
    AnaliseCreditoEmissao: ensureString(ratingEmissao.AnaliseCreditoEmissao) || null
})